import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy, CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { IconModule, IconSetModule, IconSetService } from '@coreui/icons-angular';
import { AppComponent } from './app.component';
import { NgOtpInputModule } from 'ng-otp-input'

// Import containers
import { DefaultLayoutComponent } from './pages/containers';

import { P404Component } from './pages/error/404.component';
import { P500Component } from './pages/error/500.component';
import { UserloginComponent } from './pages/userlogin/userlogin.component';
import { UserprofileComponent } from './pages/userprofile/userprofile.component';
import { RegisterComponent } from './pages/register/register.component';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts';
import { SchoolComponent } from './pages/school/school.component';
import { ForgotPasswordComponent } from "./pages/forgotpassword/forgotpassword.component";

import { UtilService } from './service/Util/Util';
import { RequestService } from './service/api/request.service';
import { AuthGuardService } from './service/auth/auth-guard.service';
import { AuthService } from './service/auth/auth.service';
import { CustomModalModule } from './component/modal/custom-modal.module';
import { ShareDataService } from './service/share-data/share-data.service';
import { TermsModule } from './pages/terms/terms.module'
import { MobileModeGuardService } from './service/mobilemodecheck/mobilemode-guard.service';
import { MobileModeService } from './service/mobilemodecheck/mobilemode.service';
import { LateModeGuardService } from './service/late/late-guard.service';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    AppSidebarModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    IconModule,
    CommonModule,
    IconSetModule.forRoot(),
    CustomModalModule,
    NgOtpInputModule,
    TermsModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    P404Component,
    P500Component,
    UserloginComponent,
    UserprofileComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    SchoolComponent,
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    IconSetService,
    UtilService,
    RequestService,
    AuthGuardService,
    AuthService,
    ShareDataService,
    MobileModeGuardService,
    MobileModeService,
    LateModeGuardService,
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
